<div class="person-explorer-volunteering-part">
	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="personExplorer.explorer.customGridHeight()" [rows]="volunteering()"></grid-content>
</div>